// Custom Quantity
$(document).on('click', '.plus-quantity', function() {
	let selectQuantity = $(this)
		.parent()
		.find('.total-quantity');
	let selectInput = $(this)
		.parent()
		.next();
	let selectLine = selectInput.data('line');
	let selectInputMax = parseInt(selectInput.attr('max'));
	let quantityNumber = selectQuantity.text();
	let quantityToNumber = parseInt(quantityNumber);
	let increaseNumber = quantityToNumber + 1;
	if (increaseNumber > selectInputMax) {
		alert('There are no more available products from this option.');
		return;
	} else {
		addProduct(increaseNumber, selectLine, $('.popup-cart .popup__body, .section-cart'));
	}
});

$(document).on('click', '.minus-quantity', function() {
	let selectQuantity = $(this)
		.parent()
		.find('.total-quantity');
	let selectInput = $(this)
		.parent()
		.next();
	let selectLine = selectInput.data('line');
	let quantityNumber = selectQuantity.text();
	let quantityToNumber = parseInt(quantityNumber);
	let decreaseNumber = quantityToNumber - 1;
	removeProduct(selectInput, selectLine, decreaseNumber, $('.popup-cart .popup__body, .section-cart'));
});
//functions
function loadQuantity() {
	$('.table--cart .field--quantity').each(function() {
		let $this = $(this);
		let val = $this.val();
		$this
			.siblings('.field-quantity--custom')
			.find('.total-quantity')
			.text(val);
	});
}

function removeProduct(selectInput, selectLine, decreaseNumber, $cartPopupContent) {
	if (decreaseNumber <= 0) {
		selectInput.closest('tr').slideUp(200);
	}

	$.ajax({
		url: `/cart/change?line=${selectLine}&amp;quantity=${decreaseNumber}`,
		beforeSend: function() {
			$('.popup-cart').addClass('loads');
			$('.section-cart').addClass('loads');
		},
		complete: function() {
			$('.popup-cart').removeClass('loads');
			$('.section-cart').removeClass('loads');
		}
	}).done(function(data) {
		populateCartPopup($cartPopupContent, data);
		loadQuantity();
	});
}

function addProduct(increaseNumber, selectLine, $cartPopupContent) {
	$.ajax({
		url: `/cart/change?line=${selectLine}&amp;quantity=${increaseNumber}`,
		beforeSend: function() {
			$('.popup-cart').addClass('loads');
			$('.section-cart').addClass('loads');
		},
		complete: function() {
			$('.popup-cart').removeClass('loads');
			$('.section-cart').removeClass('loads');
		}
	}).done(function(data) {
		populateCartPopup($cartPopupContent, data);
		loadQuantity();
	});

	$.ajax({
		url: '/cart',
		type: 'GET',
		beforeSend: function() {
			$('.popup-cart').addClass('loads');
			$('.section-cart').addClass('loads');
		},
		complete: function() {
			$('.popup-cart').removeClass('loads');
			$('.section-cart').removeClass('loads');
		}
	}).done(function(data) {
		$cartPopupContent.html(
			$(data)
				.find('.section-cart')
				.html()
		);
		loadQuantity();
	});
}

// populate Cart Popup
function populateCartPopup($cartPopupContent, data) {
	var $cartTextLink = $('.cart-link .count');

	var cartTextNew = $(data)
		.find('.item-counter')
		.text();

	$cartTextLink.text(cartTextNew);

	var count = parseInt(cartTextNew);

	$cartPopupContent.html(
		$(data)
			.find('.section-cart')
			.html()
	);
}

module.exports = {
	loadQuantity
};
